import { gql } from '@apollo/client';

export const REQUEST_FILTRO = gql`
    query GetFiltroAutocompletar($cubo: String!, $atributo: String!, $valor: String, $filtros: [Filtro]) {
        iAutocompletar(cubo: $cubo, atributo: $atributo, valor: $valor, filtros: $filtros)
    }
`;

export const GET_METADADOS_ETL = gql`
    query GetMetadadosEtl($cubo: String!) {
        iMetaETL(cubo: $cubo) {
            tipo
            dtInicioProcessamento
            dtProcessado
            dtUltimoRegistro
            statusPorcentagem
        }
    }
`;

export const GERAR_DATASET_MONGO = gql`
    query GerarDataset($cubo: String!, $atributos: [String], $filtros: [Filtro], $medidas: [MedidaOrString]) {
        iMongoDataset(cubo: $cubo, atributos: $atributos, filtros: $filtros, medidas: $medidas)
    }
`;